import { render, staticRenderFns } from "./BaseSearchComponent.vue?vue&type=template&id=487cb778&"
import script from "./BaseSearchComponent.vue?vue&type=script&lang=ts&"
export * from "./BaseSearchComponent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports